/**
 * SVT Shader
 */
const vert = `#version 300 es
in vec2 a_position;
in vec2 a_uv;
uniform mat3 u_matrix;
out vec2 v_uv;

void main() {
    gl_Position = vec4((u_matrix * vec3(a_position, 1.0)).xy, 0.0, 1.0);
    v_uv = a_uv;
}`;

const frag = `#version 300 es
precision highp float;

// uniform sampler2D u_svtCacheTexture;
uniform highp sampler2DArray u_svtCacheTexture;
uniform sampler2D u_indirectionTable;

uniform sampler2D u_fontTexture;

uniform float u_tileSize;
uniform float u_svtDepth;
uniform vec2 u_svtResolution;

// mouse hover
uniform vec2 u_mouse;
uniform vec2 u_quadSize;
uniform vec2 u_gridSize;

uniform bool u_debug;

in vec2 v_uv;
layout(location = 0) out vec4 fragColor;
layout(location = 1) out float lodValue;

float mipmapLevel(in vec2 texelCoord, in float bias) {
    vec2 dxVtc = dFdx(texelCoord);
    vec2 dyVtc = dFdy(texelCoord);
    float deltaMaxSqr = max(dot(dxVtc, dxVtc), dot(dyVtc, dyVtc));
    return 0.5 * log2(deltaMaxSqr) + bias;
}

// vec4 queryIndirectionBuffer(sampler2D indirection, vec2 texCoords, float bias) {
//     float lod = clamp(floor(mipmapLevel(texCoords * u_svtResolution, bias)), 0.0, u_svtDepth);
//     vec4 indirectionEntry = textureLod(indirection, texCoords, lod);

//     while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
//         lod += 1.0;
//         indirectionEntry = textureLod(indirection, texCoords, lod);
//     }
//     return indirectionEntry;
// }

vec4 queryIndirectionBuffer(sampler2D indirection, vec2 texCoords, float bias) {
    float lod = clamp(floor(mipmapLevel(texCoords * u_svtResolution, bias)), 0.0, u_svtDepth);
    vec4 indirectionEntry = textureLod(indirection, texCoords, lod);
    indirectionEntry.r *= 255.0;
    indirectionEntry.b *= 255.0;
    while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
        lod += 1.0;
        indirectionEntry = textureLod(indirection, texCoords, lod);
        indirectionEntry.r *= 255.0;
        indirectionEntry.b *= 255.0;
    }
    return indirectionEntry;
}

/**
 * Converts regular texture coordinates to texture coordinates in the SVT buffer texture
 * using the indirection texture.
 */
// vec2 svtTexCoords(sampler2D indirection, vec2 texCoords, float bias) {
//     float cacheSizeInTiles = float(textureSize(u_svtCacheTexture, 0).x) / u_tileSize;
//     vec4 indirectionEntry = queryIndirectionBuffer(indirection, texCoords, bias);

//     vec2 pageCoord = indirectionEntry.rg; // i, j
//     float reverseMipmapLevel = indirectionEntry.b;
//     float mipExp = exp2(reverseMipmapLevel);
//     vec2 withinPageCoord = fract(texCoords * mipExp); //* vec2(1.0, 1.0));
//     // The next line prevents bilinear filtering artifacts due to unrelated tiles being side-by-side in the cache.
//     // For each tile, we sample an area (tile_resolution - 2)^2, leaving a 1px border which should be filled with
//     // data from the adjacent tiles. However, in high resolution tiles (512, 1024, etc.), this 1 pixel is not
//     // noticeable at all if the border is not set up in the tiles.
//     withinPageCoord = (withinPageCoord * (u_tileSize - 2.0) / u_tileSize) + (1.0 / u_tileSize);
//     return (pageCoord + withinPageCoord) / cacheSizeInTiles;
// }

vec3 svtTexCoords(sampler2D indirection, vec2 texCoords, float bias) {
    vec4 indirectionEntry = queryIndirectionBuffer(indirection, texCoords, bias);
    // float layerIndex = floor(indirectionEntry.r + 0.5);
    float layerIndex = indirectionEntry.r;
    float reverseMipmapLevel = indirectionEntry.b;
    float mipExp = exp2(reverseMipmapLevel);

    // float texelSize = 1.0 / u_tileSize;
    // vec2 adjustedTexCoords = texCoords * mipExp + 0.5 * texelSize; // Offset by half texel
    // vec2 withinTileCoord = fract(adjustedTexCoords);
    // // Scale to avoid edges
    // // withinTileCoord = withinTileCoord * (1.0 - texelSize) + 0.5 * texelSize;

    // return vec3(withinTileCoord, layerIndex);

    vec2 withinTileCoord = fract(texCoords * mipExp);
    return vec3(withinTileCoord, layerIndex);
}

// vec2 svtTexCoords(sampler2D indirection, vec2 texCoords) {
//     return svtTexCoords(indirection, texCoords, 0.0);
// }

vec3 svtTexCoords(sampler2D indirection, vec2 texCoords) {
    return svtTexCoords(indirection, texCoords, 0.0);
}

void main() {    
    vec3 physicalUV = svtTexCoords(u_indirectionTable, v_uv, -0.5);

    fragColor = texture(u_svtCacheTexture, physicalUV);
    // fragColor = vec4(physicalUV.xy, physicalUV.z / float(36), 1.0);
    // fragColor = vec4(vec3(physicalUV.b / 50.0), 1.0);

    // vec4 indirectionEntry = queryIndirectionBuffer(u_indirectionTable, v_uv, 0.0);
    // float lod = clamp(floor(mipmapLevel(v_uv * u_svtResolution, 0.0)), 0.0, u_svtDepth);
    // while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
    //     lod += 1.0;
    //     indirectionEntry = textureLod(u_indirectionTable, v_uv, lod);
    // }
    // float reverseMipmapLevel = indirectionEntry.b;
    // float mipExp = exp2(reverseMipmapLevel);
    // vec2 gradX = dFdx(v_uv) * mipExp / u_tileSize;
    // vec2 gradY = dFdy(v_uv) * mipExp / u_tileSize;
    // fragColor = textureGrad(u_svtCacheTexture, physicalUV, gradX, gradY);

    // if (physicalUV.x < 0.001 ||  physicalUV.y < 0.001 ) {
    //     fragColor = vec4(0.0, 1.0, 0.0, 1.0);
    // }
    // if (physicalUV.x > 0.999 || physicalUV.y > 0.999) {
    //     fragColor = vec4(0.0, 0.0, 1.0, 1.0);
    // }

    if (u_debug) {
        vec4 indirectionEntry = queryIndirectionBuffer(u_indirectionTable, v_uv, 0.0);
        float lod = clamp(floor(mipmapLevel(v_uv * u_svtResolution, 0.0)), 0.0, u_svtDepth);
        while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
            lod += 1.0;
            indirectionEntry = textureLod(u_indirectionTable, v_uv, lod);
        }
        // float lod = clamp(floor(mipmapLevel(v_uv * u_svtResolution, 0.0)), 0.0, u_svtDepth);
        // float s = exp2(lod);
        // vec2 texelSize = vec2(1.0 / s, 1.0 / s);
        // vec2 adjustedTexCoords = v_uv - mod(v_uv, texelSize) + 0.5 * texelSize;
        // vec4 indirectionEntry = textureLod(u_indirectionTable, adjustedTexCoords, lod);

        // // Fallback to higher mipmap levels if needed
        // while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
        //     lod += 1.0;
        //     s = exp2(lod);
        //     texelSize = vec2(1.0 / s, 1.0 / s);
        //     adjustedTexCoords = v_uv - mod(v_uv, texelSize) + 0.5 * texelSize;
        //     indirectionEntry = textureLod(u_indirectionTable, adjustedTexCoords, lod);
        // }
        vec2 tileUV = fract(v_uv * exp2(indirectionEntry.b));  // local UV within the tile (0-1)

        // Render LOD text on each tile
        vec2 textSize = vec2(0.1, 0.1);
        vec2 textPos = vec2(0.5 - textSize.x / 2.0, 0.5 - textSize.y / 2.0);
        if (tileUV.x >= textPos.x && tileUV.x < textPos.x + textSize.x &&
            tileUV.y >= textPos.y && tileUV.y < textPos.y + textSize.y) {
            float charIndex = floor(u_svtDepth - lod);
            vec2 fontUV = vec2(
                (charIndex * 16.0 + (tileUV.x - textPos.x) * 16.0 / textSize.x) / 256.0,
                (tileUV.y - textPos.y) / textSize.y
            );
            vec4 textColor = texture(u_fontTexture, fontUV);
            if (textColor.a > 0.5) {
                fragColor = vec4(1.0, 1.0, 1.0, 1.0);  // White text
            }
        }
        // float level = indirectionEntry.b;
        // // Color based on LOD: red for level 0, green for 1, blue for 2
        // vec3 debugColor = vec3(0.0);
        // if (level == 0.0) debugColor.r = 1.0;
        // else if (level == 1.0) debugColor.g = 1.0;
        // else if (level == 2.0) debugColor.b = 1.0;
        // fragColor.rgb = mix(fragColor.rgb, debugColor, 0.2);

        vec2 mouseRelative = (u_mouse + u_quadSize / 2.0) / u_quadSize;
        vec2 hoveredCell = floor(mouseRelative * u_gridSize);
        vec2 cellIndex = floor(v_uv * u_gridSize);
        bool isHovered = all(equal(cellIndex, hoveredCell));
        if (isHovered) {
            fragColor.rgb = mix(fragColor.rgb, vec3(1.0, 0.0, 0.0), 0.5);
            // fragColor.rgb = vec3(1.0, 0.0, 0.0);
        }
    }
    
}`;

/**
 * Visible tile detection
 */
const detectFrag = `#version 300 es
precision highp float;

uniform float u_svtDepth;
uniform float u_svtDetectionScaleFactor; // = -log2(svtDetectionFactor);
uniform vec2 u_svtResolution;

in vec2 v_uv;
out vec4 fragColor;


float mipmapLevel(in vec2 texelCoord, in float bias) {
    vec2 dxVtc = dFdx(texelCoord);
    vec2 dyVtc = dFdy(texelCoord);
    float deltaMaxSqr = max(dot(dxVtc, dxVtc), dot(dyVtc, dyVtc));
    return 0.5 * log2(deltaMaxSqr) + bias;
}

void main() {
    float mip = clamp(floor(mipmapLevel(v_uv * u_svtResolution, u_svtDetectionScaleFactor)), 0.0, u_svtDepth);
    float reverseMipmapLevel = u_svtDepth - mip;
    float mipExp = exp2(reverseMipmapLevel);

    vec2 tileXY = floor(v_uv * mipExp);
    fragColor = vec4(reverseMipmapLevel, tileXY.x, tileXY.y, 1.0); // LOD, col, row, valid
}`;

/**
 * SVT Cache Debugging
 */
const vertDebug = `#version 300 es
in vec2 a_position;
in vec2 a_uv;

out vec2 v_uv;

void main() {
    gl_Position = vec4(a_position, 0.0, 1.0);
    v_uv = a_uv;
}`;

const fragDebug = `#version 300 es
precision highp float;

uniform sampler2D uAtlasTexture;
uniform vec2 uAtlasSize;
uniform vec2 uTileSize;

in vec2 v_uv;
out vec4 fragColor;

void main() {
    vec2 atlasUV = vec2(v_uv.x, 1.0 - v_uv.y);
    vec4 color = texture(uAtlasTexture, atlasUV);
    fragColor = color;
}`;

export default {
    vert, frag, detectFrag, vertDebug, fragDebug
}